import { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import InvoiceFilterModal from "../modals/invoice/InvoiceFilterModal";
import { useAuthStore } from "../../store/auth.store";
import number_format from "../../utils/number_format";
import { useTranslation } from "../../hooks/useTranslation";

export function InvoiceFilterActual({ setFilter, filter }) {
  const { t } = useTranslation();
  const deleteFromFilter = (key) => {
    setFilter({ ...filter, [key]: false });
  };

  const user = useAuthStore((state) => state.user);

  const deletableFilters = [
    ["invoice_date_ge", t("invoices.invoiceDateFrom"), "date"],
    ["invoice_date_le", t("invoices.invoiceDateTo"), "date"],
    ["invoice_paid_date_ge", t("invoices.paidDateFrom"), "date"],
    ["invoice_paid_date_le", t("invoices.paidDateTo"), "date"],
    ["invoice_due_date_ge", t("invoices.dueDateFrom"), "date"],
    ["invoice_due_date_le", t("invoices.dueDateTo"), "date"],
    ["vendors", t("deals.vendors"), "vendors"],
    ["purchase_total_amount_local_currency_ge", t("invoices.amountFrom"), "number"],
    ["purchase_total_amount_local_currency_le", t("invoices.amountTo"), "number"],
  ];

  let isFilterFill = false;

  deletableFilters.forEach((deletableFilter) => {
    if (deletableFilter[0] in filter && filter[deletableFilter[0]]) {
      isFilterFill = true;
    }
  });

  if (!isFilterFill) {
    return <></>;
  }

  return (
    <div className="d-lg-flex gap-2 py-3 border-bottom">
      {deletableFilters.map(
        (deletableFilter, key) =>
          deletableFilter[0] in filter &&
          filter[deletableFilter[0]] &&
          (!Array.isArray(filter[deletableFilter[0]]) ||
            (Array.isArray(filter[deletableFilter[0]]) &&
              filter[deletableFilter[0]].length > 0)) && (
            <>
              <div className="btn-group" key={key}>
                <button className="btn btn-sm btn-secondary">
                  {deletableFilter[1]}:&nbsp;
                  <strong>
                    {deletableFilter[2] === "date" &&
                      new Date(filter[deletableFilter[0]]).toLocaleDateString()}

                    {deletableFilter[2] === "number" &&
                      number_format(filter[deletableFilter[0]], 2, ",", ".")}

                    {deletableFilter[2] === "vendors" &&
                      user &&
                      user.role &&
                      filter[deletableFilter[0]].map(
                        (vendor_id, vindex) =>
                          (vindex > 0 ? ", " : "") +
                          user.role
                            .find((r) => r.role_id === "vendors")
                            ?.val.find(
                              (vendor) => vendor.vendor_id === vendor_id
                            )?.vendor
                      )}
                  </strong>
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => deleteFromFilter(deletableFilter[0])}
                >
                  <i className="ki-solid ki-trash text-white"></i>
                </button>
              </div>
            </>
          )
      )}
    </div>
  );
}
